import { colorsPalettes } from "@similarweb/styles";
import { ScrollArea } from "@similarweb/ui-components";
import styled from "styled-components";

export const Border = styled.span`
    display: block;
    margin: 0 8px;
    border-bottom: 1px solid ${colorsPalettes.carbon["50"]};
`;

const SelectedItemsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin: 0px 7px;
    padding: 2px 0 5px 0;
`;

export const SrollWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

const SegemntsScrollArea = styled(ScrollArea)`
    max-height: 130px;
    min-width: 400px;
`;
